import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportsAPIService } from '../API/ReportsAPI.service';
@Injectable({
  providedIn: 'root'
})
export class ReportsService{
  configUrl: string;
  headers: HttpHeaders;
  constructor(private reportsService: ReportsAPIService) {
  }

  postLocationsTabToExcel(selectedTab: string, idLocationCategory: number, finder: string, filtersRequest : any[]): any {
    return this.reportsService.postLocationsTabToExcel(selectedTab, idLocationCategory, finder, filtersRequest);
  }

  postLocationsByIdentifiersToExcel(identifiers: string[]): any {
    return this.reportsService.postLocationsByIdentifiersToExcel(identifiers);
  }

  getReportLastLocationsAllVINs() {
    return this.reportsService.getReportLastLocationsAllVINs();
  }

  getReportLocationInventory() {
    return this.reportsService.getReportLocationInventory();
  }
}
